import { StorageService } from './storage.service';
import jwtPayloadDecoder from 'jwt-payload-decoder';
import { Injectable } from '@angular/core';

@Injectable()
/**
 * This service handled JWT token decoding to fetch the application's
 * "Squanchy" cookie and the included info.
 */
export class JwtDecoder {
  constructor(private storage: StorageService) {}
  getUserInformation() {
    var token = this.storage.getCookie('squanchy');
    if (token) {
      var userInformation = jwtPayloadDecoder.getPayload(token);
      return userInformation;
    }
    return;
  }
}
